import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getEbusInfo = async (id) => {
  try {
    const response = await apiWrapper(
      "GET",
      `serviceAreas/${id}`,
      null,
      false,
      false,
      "E-BUS"
    );
    console.log("getEbusInfo response.data :>> ", response.data);
    return response.data;
  } catch (err) {
    console.log('ERROR"" getEbusInfo():', err);
    throw err;
  }
};
